import { Col } from './col';
import { Row } from './row';
import { Subscription, merge } from 'rxjs';
import { TableHandler } from './table';
import { Option } from '../../../option';

export class Cell {
  get id(): string {
    return this.option.id;
  }
  get col(): Col {
    return this.table.columns.find(c => c.id === this.colId);
  }
  get row(): Row {
    return this.table.rows.find(r => r.id === this.rowId);
  }
  get colId(): string {
    return (this.option.id || '').split('-')[0];
  }
  get rowId(): string {
    return (this.option.id || '').split('-')[1];
  }
  get text(): string {
    return this.option.text;
  }
  set text(v: string) {
    this.option.text = v;
  }
  get quota(): number {
    return this.option.quota;
  }
  set quota(v: number) {
    this.option.quota = v;
  }
  get canHaveQuota(): boolean {
    return this.option.question.canHaveQuotaOptions;
  }
  subscriptions: Subscription[] = [];
  constructor(private table: TableHandler, public option: Option) {
    this.subscriptions.push(
      merge(
        this.col.getChildTracker('text').onContentUpdate,
        this.row.getChildTracker('text').onContentUpdate
      ).subscribe(() => {
        this.text = `${this.col.text} ${this.row.text}`;
      })
    );
  }
  destroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
